import { z } from 'zod';
import { randomNumber } from '../utils';

export const contactInformationTypeSchema = z.object({
  ContactInformationType: z.string(),
  idContactInformationType: z.number().min(1),
});

export const contactInformationSchema = z.object({
  idContactInformation: z.number(),
  idContactInformationType: z.number().min(1),
  idContactInformationForm: z.number().optional(),
  idLegalClientContactInformation: z.number().optional(),
  Contact: z.string().trim().min(1),
  ContactInformationType: z.string().trim().min(1),
  ContactInformationForm: z.string().optional(),
});

export type ILegalClientContactInformation = z.infer<
  typeof contactInformationSchema
>;

export type ILegalClientContactInformationType = z.infer<
  typeof contactInformationTypeSchema
>;

export const initContactInformation = (): ILegalClientContactInformation => ({
  idContactInformation: randomNumber() * -1,
  idLegalClientContactInformation: -1,
  Contact: '',
  ContactInformationType: 'Telefon',
  idContactInformationType: 1,
});
